// Global Instructions Rule Applied!
//
// Stage-aging alerts (Phase 6): the navbar bell read (view__stage_alerts via
// GET /stage-alerts). One row per active alert visible to the signed-in
// user's email; days is LIVE (recomputed at read), colour is the stage's
// configured band colour for the alert's severity (null → chip defaults).
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const StageAlertSchema = z
  .object({
    stage_alerts__id: z.string(),
    stage_alerts__severity: z.enum(['warn', 'crit']),
    stage_alerts__fired_at: z.string(),
    stage_alerts__days: z.number(),
    stage_alerts__colour: z.string().nullish(),
    stage_alerts__read: z.boolean(),
    pipeline_deals__stage_date: z.string().nullish(),
    deals__id: z.string(),
    deals__name: z.string().nullish(),
    accounts__id: z.string().nullish(),
    accounts__name: z.string().nullish(),
    pipelines__id: z.string(),
    pipelines__name: z.string().nullish(),
    pipelines__type: z.string().nullish(),
    pipeline_stages__name: z.string().nullish()
  })
  .strict()

export const StageAlertsResponseSchema = z
  .object({
    alerts: z.array(StageAlertSchema),
    unread_count: z.number()
  })
  .strict()

export type StageAlertModel = z.infer<typeof StageAlertSchema>
export type StageAlertsResponseModel = z.infer<typeof StageAlertsResponseSchema>

export function validateStageAlertsResponse(data: unknown): StageAlertsResponseModel {
  return validateWithZodSchema(StageAlertsResponseSchema, data, 'stage alerts') as StageAlertsResponseModel
}
